import _ from 'lodash';
import {useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {wardsList} from '../store/reducers/ward';
import {emergencyDepartment, trudWardsDict} from '../store/reducers/dicts';
import {useLocation} from 'react-router-dom';
import {MAP_TYPE} from '../util/mapCreator/mapUtils';

export default function usePatientLocation(patient) {
    const wardList = useSelector(wardsList);
    const trudWardList = useSelector(trudWardsDict);
    const edList = useSelector(emergencyDepartment);

    const match = useLocation();
    const stableMatch = useMemo(() => match, [match.pathname]);

    const [patientLocation, setPatientLocation] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (patient) {
            const {wardId} = patient;

            setLoading(true);
            let findWard = _.find(wardList, ward => ward.wardsId.includes(wardId));
            if (findWard) {
                const ward = _.find(findWard?.type === MAP_TYPE.ED ? edList : trudWardList, {wardCode: wardId});
                setPatientLocation({
                    ...findWard,
                    trudDescription: ward?.wardName || 'UNKNOWN',
                    wardType: checkWardType(findWard),
                });
            } else {
                setPatientLocation(null);
            }
            setLoading(false);
        } else {
            setPatientLocation(null);
            setLoading(false);
        }
    }, [trudWardList, wardList, edList, stableMatch, patient]);

    const checkWardType = useMemo(() => (wardMap) => {
        if (wardMap) {
            return wardMap?.type === MAP_TYPE.ED ? 'ED' : 'IP';
        }
        return 'UNKNOWN';
    }, [stableMatch]);

    return [patientLocation, loading];
}